import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function IosShareIcon(props: IconProps) {
    return <Icon {...props} iconKey={"ios_share"}/>
}
